import React from 'react';
import { Beer } from 'lucide-react';

const MenuRow = ({ name, ingredients }) => (
  <div className="flex justify-between items-start gap-4 py-3 border-b border-gray-200 last:border-b-0">
    <div className="flex-1 min-w-0">
      <p className="font-semibold text-gray-800">{name}</p>
      {ingredients && <p className="text-sm text-gray-500 mt-1">{ingredients}</p>}
    </div>
  </div>
);

const MenuSection = ({ title, subtitle, children }) => (
  <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
    <div className="pb-3 border-b-2 border-gray-300 mb-4">
      <h3 className="text-xl font-bold text-blue-700 uppercase tracking-wide">{title}</h3>
      {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
    </div>
    <div className="space-y-1">{children}</div>
  </div>
);

const Obcerstveni = () => {
  return (
    <section className="py-16 px-4 bg-gray-50 min-h-screen" data-testid="obcerstveni-section">
      <div className="container mx-auto max-w-4xl">
        
        {/* HLAVIČKA */}
        <div className="text-center mb-12">
          <Beer className="w-16 h-16 mx-auto text-blue-600 mb-4" />
          <h2 className="text-4xl font-bold text-gray-800">Občerstvení</h2>
          <p className="text-gray-600 mt-2">Nápojový lístek</p>
        </div>

        <div className="space-y-6">
          {/* TOČENÉ NÁPOJE */}
          <MenuSection title="Točené nápoje" subtitle="0,5l / 0,3l">
            <MenuRow name="ŠERÁK 11° (nostalgie)" />
            <MenuRow name="LITOVEL ČERNÉ 12°" />
            <MenuRow name="KOFOLA, MALINA, BEZINKA" />
          </MenuSection>

          {/* ŘEZANÁ PIVA (FOTOGALERIE) */}
          <MenuSection title="Řezaná piva">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-2">
              <div className="aspect-square overflow-hidden rounded-xl shadow-sm bg-gray-200">
                <img src="/foto1.jpg" alt="Řezané pivo 1" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl shadow-sm bg-gray-200">
                <img src="/foto2.jpg" alt="Řezané pivo 2" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl shadow-sm bg-gray-200">
                <img src="/foto3.jpg" alt="Řezané pivo 3" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square overflow-hidden rounded-xl shadow-sm bg-gray-200">
                <img src="/foto4.jpg" alt="Řezané pivo 4" className="w-full h-full object-cover" />
              </div>
            </div>
          </MenuSection>

          {/* LÁHVOVÉ NÁPOJE */}
          <MenuSection title="Láhvové nápoje" subtitle="0,5l">
            <MenuRow name="ŠERÁK LAHVOVÉ" />
            <MenuRow name="PITO LAHVOVÉ" />
            <MenuRow name="ČERNÝ CITRÓN LAHV." />
            <MenuRow name="ČERNÝ CITRÓN NEALKO LAHV." />
            <MenuRow name="BIRELL NEOCHUCENÝ" />
          </MenuSection>

          {/* VÍNO */}
          <MenuSection title="Víno" subtitle="2 dcl">
            <MenuRow name="VELTLÍNSKÉ ZELENÉ" />
            <MenuRow name="MODRÝ PORTUGAL" />
            <MenuRow name="CHARDONNAY" />
          </MenuSection>

          {/* DŽUSY */}
          <MenuSection title="Džusy" subtitle="2 dcl">
            <MenuRow name="POMERANČ" />
            <MenuRow name="JAHODA" />
          </MenuSection>

          {/* MÍCHANÉ NÁPOJE */}
          <MenuSection title="Míchané nápoje">
            <MenuRow name="APEROL SPRITZ" ingredients="Aperol, Prosecco, Sifon, Led, Pomeranč" />
            <MenuRow name="GIN & TONIC (pink)" ingredients="Gin, Tonic, Citrón, Led" />
            <MenuRow name="BETON" ingredients="Becherovka, Tonic, Citrón, Led" />
            <MenuRow name="BAVORÁK" ingredients="Fernet, Tonic, Citrón, Led" />
          </MenuSection>

          {/* KÁVA */}
          <MenuSection title="Káva">
            <MenuRow name="Turek, rozpustná" />
            <MenuRow name="Espresso" />
            <MenuRow name="Espresso lungo" />
            <MenuRow name="Capuccino" />
            <MenuRow name="Latte" />
          </MenuSection>

          {/* ČAJ A HORKÉ NÁPOJE */}
          <MenuSection title="Čaj a horké nápoje">
            <MenuRow name="ČAJ dle nabídky" />
            <MenuRow name="SVAŘÁK" />
            <MenuRow name="HORKÁ GRIOTKA" />
            <MenuRow name="GROG" />
          </MenuSection>
        </div>
      </div>
    </section>
  );
};

export default Obcerstveni;
